import Urls from "./url"

/**
 * 
 * @returns 
 */
export const fetchOrgPages = async (categories: [any]) => {
    let catList = categories.join(',');
    const url = Urls('organizationUrl', catList);
    //console.log(catList)
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
/**
 * 
 * @returns 
 */
export const TfetchOrgPagesFiterable = async (categories: [any], lan: string) => {
    let catList = categories.join(',');
    const url = Urls('orgsCustomUrl', catList, lan);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const fetchOrgPagesFiterable = async (categories: string[], lan: string) => {
    const catList = categories.join(',');
    let allData: any[] = [];
    let page = 1;
    let totalPages = 1;

    do {
        const url = Urls('orgsCustomUrl', catList, lan, page);
        const resp = await fetch(url);

        if (!resp.ok) {
            return {
                message: null,
                error: resp.statusText
            };
        }

        const data = await resp.json();
        allData = allData.concat(data);

        // Set totalPages based on the headers
        if (page === 1) {
            const headerTotalPages = resp.headers.get('X-WP-TotalPages');
            totalPages = headerTotalPages ? parseInt(headerTotalPages, 10) : 1;
        }

        page++;
    } while (page <= totalPages);

    return {
        message: allData,
        error: null
    };
};

export const fetchRandomOrgPages = async (lan?: string) => {

    let url = '';

    if (lan && lan.length>1) {

        url = Urls('randomPosts', 'organisationpage', '4',lan);

    } else {

        url = Urls('randomPosts', 'organisationpage', '4','');

    }
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const fetchOrg = async (id: any) => {
    const url = Urls('organizationSingleUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const fetchBus = async (id: any) => {
    const url = Urls('businessSingleUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const fetchOrgBySlug = async (slug: any) => {
    const url = Urls('organizationSingleBySlugUrl', slug);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}


export const fetchOrgList = async () => {
    let allData: any[]|null = [];
    let page = 1;
    let totalPages = 1;

    while (page <= totalPages) {
        const resp = await fetch(Urls('organizationListUrl', page));

        if (!resp.ok) {
            return {
                message: null,
                error: resp.statusText
            };
        }

        const data = await resp.json();
        allData = allData.concat(data);

        // Set totalPages on first fetch
        if (page === 1) {
            const totalPagesHeader = resp.headers.get('X-WP-TotalPages');
            totalPages = totalPagesHeader ? parseInt(totalPagesHeader, 10) : 1;
        }

        page++;
    }

    const message = allData.filter((el: any) => {
        if (!el.acf) return true;
        if (!el.acf.inactive) return true;
        return false;
    });

    return {
        message,
        error: null
    };
};


export const fetchOrgById = async (id: any) => {
    const url = Urls('organizationSingUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const fetchOrgsWhereAdmin = async (id: any) => {
    const url = Urls('orgsWhereAdmin', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export default {}